import styled from 'styled-components';

const Wrapper = styled.div`
	position: relative;
	background: #29292c;
	.main-panel {
		width: 100%;
		min-height: 370px;
		padding: 40px 75px;
		position: relative;
		box-sizing: border-box;

		.ant-btn {
			position: absolute;
			top: 40px;
			right: 110px;
			font-size: 22px;
			height: auto;
		}
		h2 {
			text-align: center;
			font-size: 35px;
			font-weight: bold;
			max-width: 960px;
			margin: auto;
		}
		.exchange-desc {
			white-space: pre-line;
			max-width: 960px;
			margin: 14px auto;
			position: relative;
			text-align: center;
			color: #fff;
			.edit-info {
				color: #ffffff;
				cursor: pointer;
				position: absolute;
				right: 15px;
				top: -60px;
			}
		}
		.flex-box {
			display: flex;
			max-width: 960px;
    		width: 35%;
			margin: auto;
			flex-direction: column;
			> div {
				margin: 12px;
			}
			.banner {
				flex: 1;
				background-size: cover;
				background-position: center;
				background-repeat: no-repeat;
				position: relative;
				min-height: 300px;
				.edit-banner {
					color: #ffffff;
					cursor: pointer;
					position: absolute;
					right: 15px;
					top: 8px;
				}

				.info {
					position: absolute;
					left: 0;
					bottom: -45px;
					width: 100%;
					display: flex;
					justify-content: space-between;
					> span {
						position: static;
						font-size: 12px;
						white-space: nowrap;
					}
				}
			}
			.exchange-info {
				flex: 1;
				position: relative;
				.ant-btn {
					font-size: 1.1rem;
					padding-top: 4px;
					padding-bottom: 4px;
					position: static;
					margin-bottom: 0.5rem;
				}
				.exchange-info-collateral {
					margin-bottom: 0.5rem;
				}
				p {
					margin: 0.25rem auto;
					font-size: 1rem;
				}
				span {
					color: #ffffff;
				}
				.progress-bar {
					width: 100%;
					position: relative;
					background-color: #b9b9b9;
					height: 12px;
					overflow: hidden;
					.others {
						position: absolute;
						left: 0;
						top: 0;
						height: 12px;
						padding: 0;
						background-color: #f00;
					}
					.mine {
						position: absolute;
						top: 0;
						height: 12px;
						padding: 0;
						background-color: #00f;
					}
				}

				.cancel-pledge {
					text-align: center;
					color: #0000ff;
					text-decoration: underline;
					font-size: 14px;
					margin-top: 0;
					cursor: pointer;
				}
				.disabled {
					cursor: not-allowed;
					color: grey;
					opacity: 0.5;
				}
				.disclamar {
					font-size: 12px;
					color: #a9a9a9;
					margin-top: 0;
				}
				.share-area {
					display: flex;
					justify-content: space-between;
					.copy-link {
						line-height: 1;
						font-size: 12px;
						color: #00f;
						text-decoration: underline;
						cursor: pointer;
						padding-right: 8px;
						input {
							position: fixed;
							left: -999px;
							top: -999px;
						}
					}
					> a,
					> button {
						font-size: 12px;
						background-color: transparent;
						padding: 0 8px;
						border: 0;
						color: #5985ff;
						cursor: pointer;
						text-decoration: none;
						&:hover {
							color: #3A4FFF;
						}
					}
				}
				.your-stake-label {
					font-size: 18px;
				}
				.others-stake-label {
					font-size: 12px;
				}
				.removal-container {
					margin-bottom: 1rem;
    				color: #0000ff;
					a {
    					color: #0000ff;
					}
				}
			}
		}
	}
	.tabs {
		position: relative;
		&::before {
			content: '';
			display: block;
			width: 100%;
			position: absolute;
			background-color: #0E0E0F;
			left: 0;
			top: 59px;
			bottom: 0;
		}
		.ant-tabs {
			position: relative;
			z-index: 1;
			max-width: 960px;
			width: 35%;
			margin: auto;
			color: #fff;
			.ant-tabs-nav .ant-tabs-tab-active {
				color: #3A4FFF;
			}
			.ant-tabs-bar {
				margin: 0;
			}
			.edit-pitch {
				color: #ffffff;
				cursor: pointer;
				position: absolute;
				right: 15px;
				top: 70px;
			}
		}
		.tab-container {
			max-width: 620px;
			position: relative;
			padding: 12px;
		}
		.msg-alert {
			padding: 16px 0;
			text-align: center;
			background-color: #fff;
			margin-bottom: 16px;
			font-size: 16px;
			p {
				margin: 0;
			}
		}
		.pitch-container {
			max-width: 620px;
			padding: 12px;
			min-height: 300px;
			h4 {
				font-weight: bold;
			}
			p,
			pre {
                margin-bottom: 24px;
                color: #A8A8B1;
                padding: 5px;
                white-space: pre-line;
            }
		}
	}
	@media (max-width: 1200px) {
		z-index: 0;
		.collateral,
		.main-panel {
			padding: 24px;
			padding-left: 28px;
			h2 {
				font-size: 24px;
			}
			.flex-box {
				flex-direction: column;
    			width: 100% !important;
				.banner {
					min-height: 240px;
				}
			}
		}
		.main-panel {
			padding: 8px;
			padding-left: 8px;
			font-size: 12px;
			.ant-btn {
				top: 33px;
				right: 8px;
			}
		}
		.tabs .ant-tabs {
			width: 80% !important;
		}
	}
	@media (max-width:280px) {
        .tabs {
            .tab-container {
            padding: 7px;
        }
        }
    }
`;

export const FormContainer = styled.div`
	.ant-form-item {
		margin-top: 12px;
	}
	h4 {
		font-weight: bold;
	}
	h4,
	p {
		margin: 0;
		line-height: 1.4;
	}
	.ant-upload.ant-upload-select-picture-card {
		width: 335px;
	}
	@media (max-width:280px) {
        .ant-upload.ant-upload-select-picture-card {
        width: 130px;
    }
    }
    @media (min-width:360px) {
        .ant-upload.ant-upload-select-picture-card {
        width: 230px;
    }
    }
`;

export default Wrapper;
